<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="分类名称">
                  <el-input  v-model="queryForm.typeName"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreTypeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopStoreType"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopStoreType(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopStoreType(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopStoreTypeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopStoreTypeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="typeName"
        label="分类名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="typePic"
        label="分类图片"
      >
          <template slot-scope="scop">
              <el-image
                  @click='updateSrcList(scop.row.typePic)'
                  style="width: 30px; height: 30px"
                  :src="scop.row.typePic"
                  :preview-src-list="srcList"
              > </el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="分类排序"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopStoreType(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopStoreType(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopStoreType(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopStoreTypeStates[shopStoreTypeState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopStoreType"
          ref="shopStoreTypeForm"
          :rules="rules"
          label-width="90px"
          size="small"
        >
          <el-form-item
            label="分类名称"
            prop="typeName"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreType.typeName"
              :disabled="shopStoreTypeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="分类排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStoreType.sort"-->
<!--              :disabled="shopStoreTypeState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 200px"
                  :disabled="shopStoreTypeState == 'check'"
                  v-model="shopStoreType.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
            <el-form-item
                label="分类图片"
                prop="typePic"
            >
                <!--            <el-input-->
                <!--              size="small"-->
                <!--              v-model="shopStoreType.typePic"-->
                <!--              :disabled="shopStoreTypeState == 'check'"-->
                <!--            ></el-input>-->
                <el-upload
                    action=""
                    :disabled="shopStoreTypeState == 'check'"
                    class="avatar-uploader"
                    :show-file-list="false"
                    :http-request="uploadAvatar"
                    style="width: 200px"
                >
                    <img
                        v-if="shopStoreType.typePic"
                        :src="shopStoreType.typePic"
                        class="avatar"
                    />
                    <i
                        v-else
                        class="el-icon-plus avatar-uploader-icon"
                    ></i>
                </el-upload>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopStoreTypeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopStoreTypeList();
                    this.getShopStoreTypeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopStoreTypeList();
                    this.getShopStoreTypeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     typeName: '', //分类名称
                     typePic: '', //分类图片
                     sort: '', //分类排序
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopStoreTypeState: 'add',
                shopStoreTypeStates: {
                    add: '新建门店分类',
                    check: '查看门店分类',
                    edit: '修改门店分类'
                },
                srcList: [''],

                multipleSelection: [],
                shopStoreTypeList: [],
                shopStoreType: {
                    id: '', //
                    typeName: '', //分类名称
                    typePic: '', //分类图片
                    sort: '', //分类排序
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    typeName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
                    typePic: [{ required: true, message: '分类图片不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '分类排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getShopStoreTypeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopStoreTypeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopStoreTypeList = [];
            },
            resetDialog() {
                this.shopStoreTypeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      typeName: '', //分类名称
                      typePic: '', //分类图片
                      sort: '', //分类排序
                };
                this.getShopStoreTypeList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopStoreType = {
                      id: '', //
                      typeName: '', //分类名称
                      typePic: '', //分类图片
                      sort: '', //分类排序
                };
            },
            submitForm() {
                if (this.shopStoreTypeState == 'add') {
                    this.$refs.shopStoreTypeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storetype/add`,{ ...this.shopStoreType }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopStoreTypeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopStoreTypeState == 'edit') {
                    this.$refs.shopStoreTypeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storetype/edit`,{ ...this.shopStoreType }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopStoreTypeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {

                        this.shopStoreType.typePic = res.url;
                    }
                });
            },
            updateSrcList(src){
                this.srcList[0] = src
            },
            addShopStoreType() {
                this.showDialog = true;
                this.shopStoreTypeState = 'add';
            },
            checkShopStoreType(shopStoreTypeId) {
                console.log(shopStoreTypeId);
                this.currentShopStoreTypeId = shopStoreTypeId;

                this.getShopStoreTypeById();
                this.showDialog = true;
                this.shopStoreTypeState = 'check';
            },
            editShopStoreType(shopStoreTypeId) {
                console.log('shopStoreType', shopStoreTypeId);
                if (shopStoreTypeId) {
                    this.currentShopStoreTypeId = shopStoreTypeId;
                    this.getShopStoreTypeById();
                } else {
                    this.shopStoreType = { ...this.shopStoreType, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopStoreTypeState = 'edit';
            },
            deleteShopStoreType(shopStoreTypeId) {
                let ids = '';
                if (shopStoreTypeId) {
                    ids = shopStoreTypeId;
                } else {
                    ids = this.multipleSelection.map((shopStoreType) => shopStoreType.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/storetype/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreTypeList();
                                this.getShopStoreTypeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopStoreTypeList() {
                this.resetShopStoreTypeList();
                this.getShopStoreTypeList();
            },
            getShopStoreTypeList(query = {}) {
                this.loading = true;
                get(`/shop/storetype/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopStoreTypeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopStoreTypeById() {
                get(`/shop/storetype/get`,{ id: this.currentShopStoreTypeId }).then((res) =>{
                    if(res.success){
                      this.shopStoreType = { ...this.shopStoreType, ...res.shopStoreType };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopStoreTypeList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/storetype/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/storetype/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/storetype/importData`,formData);
              this.refreshShopStoreTypeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopStoreTypeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopStoreTypeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
</style>